import React from 'react';
import classNames  from 'classnames';

export default (props) => (

  <div className={classNames('accordion-head', {'with-btn': props.withBtn || false})}>
         <span className="accordion-number">
           <i className={props.icon || ''}>
             {props.number || ''}
           </i>
         </span>
    <div className="accordion-caption">
      <span className="accordion-label">{props.label}</span>
      {props.caption}
    </div>
    <span className={classNames('accordion-btn btn bordered', {
      'prime': props.btn.type === 'start',
      'green empty': props.btn.type === 'completed',
      'blue empty': props.btn.type === 'progress'
      })}>{props.btn.text}</span>
  </div>
);



// WEBPACK FOOTER //
// ./src/blocks/accordion/AccordionHead.jsx